module.exports = __webpack_public_path__ + "static/media/home-product-2.641f1037.png";